import I18n from 'i18n-js';
import ReverbBucksPaymentCard from '@reverbdotcom/cadence/images/payment-card/reverb-bucks-payment-card.svg';
import AffirmPaymentCard from '@reverbdotcom/cadence/images/payment-card/affirm-payment-card.svg';
import PaypalPaymentCard from '@reverbdotcom/cadence/images/payment-card/paypal-payment-card.svg';
import SofortPaymentCard from '@reverbdotcom/cadence/images/payment-card/sofort-payment-card.svg';
import PlaceholderPaymentCard from '@reverbdotcom/cadence/images/payment-card/placeholder-payment-card.svg';
import VisaPaymentCard from '@reverbdotcom/cadence/images/payment-card/visa-payment-card.svg';
import MastercardPaymentCard from '@reverbdotcom/cadence/images/payment-card/mastercard-payment-card.svg';
import DiscoverPaymentCard from '@reverbdotcom/cadence/images/payment-card/discover-payment-card.svg';
import AmexPaymentCard from '@reverbdotcom/cadence/images/payment-card/amex-payment-card.svg';
import ApplePayPaymentCard from '@reverbdotcom/cadence/images/payment-card/apple-pay-payment-card.svg';
import GooglePayPaymentCard from '@reverbdotcom/cadence/images/payment-card/google-pay-payment-card.svg';
import KlarnaPaymentCard from '@reverbdotcom/cadence/images/payment-card/klarna-payment-card.svg';

const PAYMENT_METHOD_TO_ICONS: { [key: string]: { source: string, translationKey: string }[] } = {
  affirm: [{ source: AffirmPaymentCard, translationKey: 'affirm' }],
  android_pay: [{ source: GooglePayPaymentCard, translationKey: 'android_pay' }],
  apple_pay: [{ source: ApplePayPaymentCard, translationKey: 'apple_pay' }],
  dc_via_paypal: [{ source: PaypalPaymentCard, translationKey: 'paypal' }],
  direct_checkout: [
    { source: VisaPaymentCard, translationKey: 'visa' },
    { source: MastercardPaymentCard, translationKey: 'mastercard' },
    { source: DiscoverPaymentCard, translationKey: 'discover' },
    { source: AmexPaymentCard, translationKey: 'amex' },
    { source: ReverbBucksPaymentCard, translationKey: 'reverb_bucks' },
  ],
  paypal: [
    { source: PaypalPaymentCard, translationKey: 'paypal' },
    { source: VisaPaymentCard, translationKey: 'visa' },
    { source: MastercardPaymentCard, translationKey: 'mastercard' },
    { source: DiscoverPaymentCard, translationKey: 'discover' },
    { source: AmexPaymentCard, translationKey: 'amex' },
  ],
  paypal_manual: [{ source: PaypalPaymentCard, translationKey: 'paypal' }],
  sofort: [{ source: SofortPaymentCard, translationKey: 'sofort' }],
  other: [{ source: PlaceholderPaymentCard, translationKey: 'other' }],
  klarna_account: [{ source: KlarnaPaymentCard, translationKey: 'klarna_account' }],
  klarna_pay_later: [{ source: KlarnaPaymentCard, translationKey: 'klarna_pay_later' }],
};

export interface PaymentMethodDisplay {
  title: string
  icons: IconDisplay[];
}

export interface IconDisplay {
  source: string;
  text: string;
}

export function displayPaymentMethod(paymentMethod: string): PaymentMethodDisplay | null {
  const lowerCasePaymentMethod = paymentMethod.toLowerCase();
  const paymentMethodIcons = PAYMENT_METHOD_TO_ICONS[lowerCasePaymentMethod];

  if (!paymentMethodIcons) {
    return null;
  }

  const title = translateTitle(lowerCasePaymentMethod);
  const icons: IconDisplay[] = paymentMethodIcons.map(icon => ({
    source: icon.source,
    text: translateIconText(icon.translationKey),
  }));

  return {
    title,
    icons,
  };
}

export function paymentMethodIcons(paymentMethod: string): IconDisplay[] | null {
  return displayPaymentMethod(paymentMethod)?.icons;
}

function translateTitle(key: string) {
  return I18n.t(`discovery.paymentMethodIcons.title.${key}`);
}

function translateIconText(key: string) {
  return I18n.t(`discovery.paymentMethodIcons.icon.${key}`);
}
